import React, { Dispatch, SetStateAction } from 'react';
import { enumValue } from '~/util';
import { ProviderAddress } from '../ProviderAddress';

export interface ProviderLocationProps {
    location: LocationType;
    selectedLocation: undefined | LocationType;
    setSelectedLocation: Dispatch<SetStateAction<LocationType>>;
}
export function ProviderLocation({
    location,
    selectedLocation,
    setSelectedLocation,
}: ProviderLocationProps) {
    const locationPhone = location.phones.find(
        (phone) => phone.type === enumValue(['core_app', 'phone_types', 'Practice'])
    );
    const locationFax = location.phones.find(
        (phone) => phone.type === enumValue(['core_app', 'phone_types', 'Practice Fax'])
    );
    const locationAddress = location.addresses?.[0];
    return (
        <div className="d-flex">
            <input
                id={`location-${location.id}`}
                className="me-1"
                type="radio"
                name="provider-location"
                value={location.id}
                checked={selectedLocation?.id === location.id}
                onChange={() => setSelectedLocation(location)}
            />
            <label
                htmlFor={`location-${location.id}`}
                className="ms-1 overflow-hidden"
                aria-label="Address"
            >
                <ProviderAddress
                    name={location.name}
                    address={locationAddress}
                    phone={locationPhone}
                    fax={locationFax}
                    isDefault={location.is_default}
                />
            </label>
        </div>
    );
}
